webpackJsonp([10],{

/***/ 1170:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/jonathan.7d7884ac.jpg";

/***/ }),

/***/ 720:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__images_jonathan_jpg__ = __webpack_require__(1170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__images_jonathan_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__images_jonathan_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_styles__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(34);










var styleSheet = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_material_ui_styles__["createStyleSheet"])("Support", function (theme) {
  return {
    picture: {
      maxWidth: 200
    }
  };
});

var Support = function Support(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
    { container: true },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
      { item: true, xs: 12, sm: 3, className: props.classes.picture },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: __WEBPACK_IMPORTED_MODULE_1__images_jonathan_jpg___default.a, alt: "Jonathan" })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_material_ui_Grid___default.a,
      { item: true, xs: 12, sm: 9 },
      "I'm Jonathan. Passionate about devops, infra, and JavaScript. I built Headless-Render-API.com (in service since 2016, rebranded from prerender.cloud 2022-05-01) to offer the market a low price, high performance headless browser solution (and because I love to build high performance stuff).",
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "p",
        null,
        "Please at least skim through the ",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Link */],
          { to: "/docs" },
          "docs"
        ),
        " and the",
        " ",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Link */],
          { to: "/docs/faq" },
          "FAQ"
        ),
        ". I also recommend reading",
        " ",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Link */],
          { to: "/docs/how-it-works" },
          "how it works, why it's needed, and caveats"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "p",
        null,
        "Send technical questions to ",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "strong",
          null,
          props.email
        ),
        " and include:",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "ol",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "li",
            null,
            "Framework version (Angular 1.x, React 14.x, etc.)"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "li",
            null,
            "a URL of the app/page in question (if possible)"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "li",
            null,
            "the server (Node.js, nginx, etc.) or service (Fly.io, CloudFront+Lambda@Edge, Netlify, etc.)"
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "p",
        null,
        "\u2014",
        " ",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "a",
          {
            href: "https://twitter.com/jotto",
            target: "_blank",
            rel: "noopener noreferrer"
          },
          "@jotto"
        ),
        " ",
        "on Twitter (but not for meaningful tech support)"
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["default"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_material_ui_styles__["withStyles"])(styleSheet)(Support));

/***/ })

});


// WEBPACK FOOTER //
// static/js/10.a81100df.chunk.js